module.exports = __webpack_public_path__ + "img/WeChat-Chat-Interface-Official-Accounts.d6849959.png";